export type IconSize = 'xs' | 's' | 'm' | 'l';

export const IconSizeMap = {
  xs: 12,
  s: 16,
  m: 20,
  l: 24,
}

export type IconType = 'actions' |
 'add-circle' |
 'add' |
 'api' |
 'archive-folder' |
 'archive' |
 'arrow-down' |
 'arrow-left' |
 'arrow-right' |
 'arrow-up' |
 'attach' |
 'billing' |
 'bot' |
 'branch' |
 'bucket' |
 'bulk' |
 'business-security' |
 'calendar' |
 'caret-down-outline' |
 'caret-down' |
 'caret-left-outline' |
 'caret-left' |
 'caret-right-outline' |
 'caret-right' |
 'caret-up-outline' |
 'caret-up' |
 'chart-bar' |
 'chart-line' |
 'chart-pie' |
 'chat-add' |
 'chat-delete' |
 'chat-message' |
 'chat-question' |
 'chat-support' |
 'checkmark' |
 'chevron-down' |
 'chevron-left' |
 'chevron-right' |
 'chevron-up' |
 'clipboard' |
 'clock' |
 'close' |
 'cloud-download' |
 'cloud-filled' |
 'cloud-security' |
 'cloud-sync' |
 'cloud-upload' |
 'cloud' |
 'collapse-all' |
 'collapse' |
 'common-services' |
 'community' |
 'configuration' |
 'copy' |
 'dashboard' |
 'delay' |
 'delete' |
 'denied' |
 'desktop' |
 'diagnostics-alt' |
 'diagnostics' |
 'dns' |
 'do-not-call' |
 'do-not-email-alt' |
 'do-not-email' |
 'doc-add' |
 'doc-contract' |
 'doc-remove' |
 'dos-protections' |
 'double-chevron-down' |
 'double-chevron-left' |
 'double-chevron-right' |
 'double-chevron-up' |
 'download' |
 'edit' |
 'email-add' |
 'email-read' |
 'email-reply' |
 'email-unread' |
 'exclamation' |
 'expand-all' |
 'expand' |
 'export' |
 'external-link' |
 'feedback' |
 'filter-filled' |
 'filter' |
 'flag-filled' |
 'flag' |
 'folder-add' |
 'folder-closed-filled' |
 'folder-closed' |
 'folder-open' |
 'folder-remove' |
 'globe' |
 'gripper' |
 'hamburger-menu' |
 'help-circle-filled' |
 'help-circle' |
 'help-documentation' |
 'hide' |
 'hierarchy' |
 'history' |
 'home' |
 'image' |
 'incognito' |
 'increment' |
 'info-filled' |
 'info' |
 'iot-cloud' |
 'ip-pin' |
 'key' |
 'kpi-bar' |
 'lightning' |
 'link' |
 'list-view' |
 'load-failure' |
 'locked' |
 'map-pin' |
 'marketplace' |
 'media' |
 'message' |
 'module' |
 'move' |
 'network-operator' |
 'network' |
 'notifications-off' |
 'notifications' |
 'origin-services' |
 'pendo-tour' |
 'phone' |
 'pin-outline' |
 'pin' |
 'pointer' |
 'print' |
 'progress' |
 'redo' |
 'reload' |
 'reset' |
 'schedule-reports' |
 'schedule' |
 'search' |
 'security-alert-filled' |
 'security-alert' |
 'security-shield' |
 'server' |
 'settings' |
 'share' |
 'show' |
 'snapshot' |
 'sort-ascending' |
 'sort-descending' |
 'sort' |
 'ssl-off' |
 'ssl' |
 'stack' |
 'star-empty' |
 'star-filled' |
 'status-alert-filled' |
 'status-alert' |
 'status-denied-filled' |
 'status-failure-filled' |
 'status-failure' |
 'status-success-filled' |
 'status-success' |
 'subtract-circle' |
 'subtract' |
 'support-headset' |
 'swap' |
 'table-view' |
 'tag-filled' |
 'tag' |
 'task' |
 'thumb-up' |
 'tip-lightbulb' |
 'tls-off' |
 'tls' |
 'undo' |
 'unlocked' |
 'upload' |
 'user-add' |
 'user-content' |
 'user-remove' |
 'user' |
 'users' |
 'view-details' |
 'waf' |
 'wizard' |
 'wrench' |
 'zoom-in' |
 'zoom-out';
